import {useState, useEffect, useMemo} from "react"
import axios from "axios"
import {API_PROJECTS} from "../../constants/apiUrls"
import SubPlayer from "../../SubPlayer/SubPlayer"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import {useTranslation} from "react-i18next"
import {toast} from "react-toastify"
import Select from "react-select"
import {labelMap} from "../../constants/multilingual"
import isLicenceValidity from "../../tools/isLicenceValidity"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import useStProjectSource from "../../swrCustomHooks/useStProjectSource"
import useStProjectWaveform from "../../swrCustomHooks/useStProjectWaveform"

export default function StWorkflowTranslation({project, setIsPulling, destinationLanguage}) {
    const {t} = useTranslation()
    const {sessionContext, setSessionAction} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {stProjectSource, isLoadingStProjectSource, isErrorStProjectSource} = useStProjectSource(project.id)
    const {stProjectWaveform, isLoadingStProjectWaveform, isErrorStProjectWaveform} = useStProjectWaveform(project.id, sessionContext.idToken, setSessionAction)
    const [srtFile, setSrtFile] = useState()
    const [latestSrt, setLatestSrt] = useState()
    const [SRTLang, setSRTLang] = useState(destinationLanguage[0].code)
    const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}

    const allLanguages = useMemo(() => {
        return destinationLanguage
            .map((lang) => ({
                value: lang.code,
                label: t(labelMap[lang.code]),
            })).sort((a, b) => a.label.localeCompare(b.label))
    }, [destinationLanguage, labelMap])

    const getTranslationSRT = (codeISO) => {
        axios.get(`${API_PROJECTS}/${project.id}/translations/${codeISO}`, headersRequest)
        .then((response) => {
            setSrtFile(response.data)
        })
        .catch((error) => {
            console.error(`GET /projects/${project.id}/translations/${codeISO}: `, error)
        })
    }

    const save = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            axios.put(`${API_PROJECTS}/${project.id}/translations/${SRTLang}`, latestSrt, headersRequest)
            .then(() => {
                toast.success(t("Subtitles saved!"), {containerId: "subplayer"})
            })
            .catch((err) => {
                toast.error(t("An error has occurred"), {containerId: "subplayer"})
                console.error("error :", err)
            })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."), {containerId: "subplayer"})
        }
    }

    const burn = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            axios.put(`${API_PROJECTS}/${project.id}/translations/${SRTLang}`, latestSrt, headersRequest)
            .then(() => {
                axios.post(`${API_PROJECTS}/${project.id}/tries`, {step: "render"}, headersRequest)
                .then(() => {
                    setIsPulling(true)
                })
                .catch((error) => {
                    console.error(`POST /projects/${project.id}/tries: `, error)
                })
            })
            .catch((error) => {
                console.error(`POST /projects/${project.id}/tries: `, error)
            })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    useEffect(() => {
        getTranslationSRT(SRTLang)
    }, [project])

    if (isErrorStProjectSource || isLoadingStProjectSource || stProjectSource.message) return <LoadingComponent/>
    return (
        <>
        <div className="SECTION ST-WORKFLOW-TRANSLATION">
            <div className="header">
                <div className="header-content">
                    <p>{t("Language")} :</p>
                    <Select
                        defaultValue={allLanguages[0]}
                        name="languages"
                        options={allLanguages}
                        isClearable={false}
                        isSearchable={false}
                        className="basic-single"
                        classNamePrefix="select"
                        onChange={(value) => {
                            getTranslationSRT(value.value)
                            setSRTLang(value.value)
                        }}
                    />
                </div>
            </div>
            <SubPlayer project={project}
                mediaUrl={stProjectSource}
                waveformUrl={stProjectWaveform}
                isLoadingWaveform={isLoadingStProjectWaveform}
                isErrorWaveform={isErrorStProjectWaveform}
                srtFile={srtFile}
                setLatestSrt={setLatestSrt}
                save={save}
            />
            {!project.finished &&
                <div className="actions">
                    <button onClick={burn} title={t("Finalize")}>{t("Finalize")}</button>
                </div>
            }
        </div>
        </>
    )
}